import React, { useMemo, useState } from "react";
import { Alert, Button, Card, Space, Typography } from "antd";
import { CopyOutlined, LinkOutlined } from "@ant-design/icons";
import { showAppToastSuccess } from "../../../utils/appToast/showAppToast";
import {
  buildAgentReferralRegistrationUrl,
  canOfferAgentReferralLink,
  formatReferralStandingCreditLine,
  listReferralStandingCreditsForReferrer,
  resolveAgentReferralCode,
} from "../../../utils/agentReferralInvite";
import "./ReferralInviteCard.scss";

const { Paragraph, Text } = Typography;

export default function ReferralInviteCard({ packageCode, agent }) {
  const [copied, setCopied] = useState(false);
  const eligible = canOfferAgentReferralLink(packageCode);
  const agentCode = resolveAgentReferralCode(agent);
  const url = useMemo(() => {
    if (!eligible || !agentCode) return "";
    const origin = typeof window !== "undefined" ? window.location.origin : "";
    return buildAgentReferralRegistrationUrl(agentCode, origin);
  }, [agentCode, eligible]);
  const credits = useMemo(
    () => (eligible ? listReferralStandingCreditsForReferrer(packageCode) : []),
    [eligible, packageCode],
  );

  if (!eligible) return null;

  async function copyLink() {
    if (!url) return;
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      showAppToastSuccess("לינק ההזמנה הועתק");
    } catch {
      setCopied(false);
    }
  }

  return (
    <Card
      className="referral-invite-card"
      title={
        <Space>
          <LinkOutlined />
          <span>לינק הזמנה לסוכנים</span>
        </Space>
      }
    >
      <Paragraph className="referral-invite-card__lead">
        שלחו את הלינק לסוכן חדש. מי שנרשם דרכו נרשם תחתיכם לניסיון של 60 יום בלי כרטיס אשראי.
      </Paragraph>
      {url ? (
        <div className="referral-invite-card__url" dir="ltr">
          {url}
        </div>
      ) : (
        <Alert type="warning" showIcon message="לא נמצא קוד סוכן ללינק. פנו לתמיכה." />
      )}
      <Button
        type="primary"
        icon={<CopyOutlined />}
        onClick={copyLink}
        disabled={!url}
        style={{ marginTop: 12 }}
      >
        {copied ? "הועתק" : "העתקת לינק"}
      </Button>
      <div className="referral-invite-card__credits">
        <Text strong>זיכוי קבוע אחרי שהסוכן מתחיל לשלם</Text>
        <Paragraph type="secondary" style={{ marginBottom: 8 }}>
          הזיכוי חודשי ונמשך כל עוד המנוי שלו בתשלום, לפי החבילה שבחר.
        </Paragraph>
        <ul>
          {credits.map((credit) => (
            <li key={credit.referredPaidPackageCode}>{formatReferralStandingCreditLine(credit)}</li>
          ))}
        </ul>
      </div>
    </Card>
  );
}
